export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9550.2ed89d0c.jpg";